import { AnalyticsState } from "./reducer"

export const getException = (state: { analytics: AnalyticsState }) => state.analytics.exception
